__turbopack_context__.v({
  "react-international-phone-dial-code-preview": "dial-code-preview-module__zhBdBa__react-international-phone-dial-code-preview",
  "react-international-phone-dial-code-preview--disabled": "dial-code-preview-module__zhBdBa__react-international-phone-dial-code-preview--disabled",
});
